var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{staticStyle:{"margin":"0px"},attrs:{"background":"","prev-text":"上一页","next-text":"下一页","layout":"prev, pager, next","page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }